import {cloneDeep} from 'lodash';
import {IRecordEmit} from '../../interfaces/record';
import {IFood, IFoodSchedule} from '../../models/food-group';
import {FoodTimeEnum} from '../../enums/meal-plan';
import {TimesEnum, TypeBetweenMealsEnum, TypesOfFatEnum} from '../../enums/record';
import {ILabelValue} from '../../interfaces/utils';
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Store} from '@ngxs/store';
import {Loader} from '../../models/loader/loader.redux';
import {IDateValue} from '../../models/patient';
import {IAllergy, IRecordNutritionalHistory, NutritionalHistoryState, RecordNutritionalHistoryAction} from '../../models/record-nutritional-history';
import {ServiceAction, ServiceState} from '../../models/service';
import {AuthState, IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';
import {ActivatedRoute, Params} from '@angular/router';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {firstValueFrom, Observable, Subscription} from 'rxjs';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {isAfter} from 'date-fns';
import {FrequencyEnum} from 'src/app/enums/record/frequency.enum';
import {PLATFORM_CONFIG} from '../../config/platform.config';
import {ICredentials} from '../../interfaces/credentials';
import {LocalStorageEnum} from '../../enums/utils';
import {SkeletonEnum} from '../../enums/skeleton';
import {SkeletonService} from '../../services/skeleton/skeleton.service';
import {NUTRITIONAL_DRESSING, NUTRITIONAL_REGIMENT} from '../../config/data/patient-record';
import {MiniSphereNamespace} from '../../namespaces/mini-sphere.namespace';
import {IIngredient} from '../../models/ingredient';

export interface ITableResponse {
  timeFoodName: FoodTimeEnum;
  submit?: boolean;
  valid: boolean;
  errorMessage?: string;
  status: 'read' | 'write';
  textValue?: string;
  from?: Date;
  to?: Date;
  quantity?: number;
  unit?: string;
}

export interface ITableTdCell {
  info: ITableResponse;
  auxInfo?: ITableResponse;
}

@Component({
  selector: 'app-record-history-nutritional',
  templateUrl: './record-history-nutritional.component.html',
  styleUrls: ['./record-history-nutritional.component.scss'],
  animations: [fadeInAnimation]
})
export class RecordHistoryNutritionalComponent implements OnInit, OnDestroy {
  wasDeployed$: Observable<boolean> = this.store.select<boolean>(NutritionalHistoryState.getWasDeployed);
  isPatient$: Observable<boolean> = this.store.select<boolean>(AuthState.getIsPatient);
  headersFoodTime: { text: string, value: FoodTimeEnum }[] = [];
  timesEnum = TimesEnum;
  frequencyEnum = FrequencyEnum;
  typesOfFat = TypesOfFatEnum;
  typeBetweenMealsEnum = TypeBetweenMealsEnum;
  confirmModal?: NzModalRef;
  nutritionalRegimen: ILabelValue[] = cloneDeep(NUTRITIONAL_REGIMENT);
  nutritionalDressings: ILabelValue[] = [];

  indexUpdate: number;

  nutritionalForm: UntypedFormGroup;
  tableForm: UntypedFormGroup;

  serviceId: string;
  patientId: string;
  expertId: string;
  clinicId: string;
  userLogged: IUser;

  @Input() recordNutritional: IRecordNutritionalHistory;
  @Output() recordNutritionalChange = new EventEmitter<IRecordEmit>();

  timeMeals: ITableTdCell[] = [];
  cereals: ITableTdCell[] = [];
  beverages: ITableTdCell[] = [];
  dressings: ITableTdCell[] = [];
  tableQuestions = [
    {
      type: 'timeMeals',
      value: 'Horarios en los que realizas tus comidas',
      data: this.timeMeals
    },
    {
      type: 'cereals',
      value: '¿Con que cereales acompañas tus comidas principales y en qué cantidad?',
      data: this.cereals
    },
    {
      type: 'beverages',
      value: '¿Con que bebidas acompañas tus comidas principales y en qué cantidad?',
      data: this.beverages
    },
    {
      type: 'dressings',
      value: '¿Utilizas aderezos o adicionas alimentos altos en grasa en tus comidas principales?',
      data: this.dressings
    }
  ];

  wasDeployedSubscription: Subscription;

  loadInfo: boolean;
  skeletonTemplate: any[] = [];
  platformConfig = PLATFORM_CONFIG;

  excludedAllergyIngredients: MiniSphereNamespace.IIngredient[] = [];
  modalAddAllergyVisible: boolean;

  excludedDislikeIngredients: MiniSphereNamespace.IIngredient[] = [];
  excludedLikeIngredients: MiniSphereNamespace.IIngredient[] = [];
  constructor(
    private modal: NzModalService,
    private store: Store,
    private storageService: StorageService,
    private utilitiesService: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private messageAlertService: MessageAlertService,
    private skeletonService: SkeletonService
  ) {
    this.wasDeployedSubscription = this.wasDeployed$.subscribe(value => {
      if (value && !this.recordNutritional) {
        this.loadInfo = false;
        this.initValuesHttp().then();
      }
    });
  }

  ngOnInit(): void {
    this.initValues();
  }

  /**
   * Inicializa las propiedades necesarias
   */
  initValues(): void {
    this.skeletonTemplate = this.skeletonService.build(SkeletonEnum.ROWS);
    this.modalAddAllergyVisible = false;
    this.headersFoodTime = [
      {
        text: 'Desayuno',
        value: FoodTimeEnum.BREAKFAST
      },
      {
        text: 'Comida',
        value: FoodTimeEnum.MEAL
      },
      {
        text: 'Cena',
        value: FoodTimeEnum.DINNER
      },
      {
        text: 'Colación 1',
        value: FoodTimeEnum.SNACK_ONE
      },
      {
        text: 'Colación 2',
        value: FoodTimeEnum.SNACK_TWO
      }
    ];
    this.headersFoodTime.forEach(header => {
      this.timeMeals.push({
        info: {
          timeFoodName: header.value,
          valid: true,
          status: 'read',
          textValue: '',
          from: null,
          to: null
        }
      });

      this.cereals.push({
        info: {
          timeFoodName: header.value,
          valid: true,
          status: 'read',
          textValue: '',
          quantity: null,
          unit: null
        }
      });

      this.beverages.push({
        info: {
          timeFoodName: header.value,
          valid: true,
          status: 'read',
          textValue: '',
          quantity: null,
          unit: null
        }
      });

      this.dressings.push({
        info: {
          timeFoodName: header.value,
          valid: true,
          status: 'read',
          textValue: ''
        }
      });
    });
    this.nutritionalRegimen = NUTRITIONAL_REGIMENT;
    this.nutritionalDressings = NUTRITIONAL_DRESSING;
    this.nutritionalForm = new UntypedFormGroup({
      feedingPreference: new UntypedFormControl(null, []),
      digestionProblems: new UntypedFormControl(null, []),
      digestionProblemsNotes: new UntypedFormControl(null, []),
      foodLikes: new UntypedFormControl(null, []),
      foodDislikes: new UntypedFormControl(null, []),
      eatMeat: new UntypedFormControl(null, []),
      cookingOilOrLard: new UntypedFormControl(null, []),
      oilName: new UntypedFormControl(null, []),
      foodTypesBetweenMeals: new UntypedFormControl(null, []),
      FoodTypesBetweenMealsConsumptionTimes: new UntypedFormControl(null, []), // TimesEnum.DAILY
      weekendFood: new UntypedFormControl(null, []),
      howManyMainMealsPerDay: new UntypedFormControl(null, []),
      howManyMainMealArePurchased: new UntypedFormControl(null, []),
      eatVegetables: new UntypedFormControl(null, []),
      howManyVegetables: new UntypedFormControl(null, []),
      eatFruits: new UntypedFormControl(null, []),
      howManyFruits: new UntypedFormControl(null, []),
      drinkSugaryDrinks: new UntypedFormControl(null, []),
      howManySugaryDrinks: new UntypedFormControl(null, []),
      eatFastFood: new UntypedFormControl(null, []),
      howOftenEatFastFood: new UntypedFormControl(null, [])
    });

    this.tableForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      allergyDate: new UntypedFormControl(null, [Validators.required])
    });
    const params: Params = this.utilitiesService.getAllParams(this.activatedRoute);
    this.clinicId = params.clinicId;
    this.patientId = params.patientId;
  }

  /**
   * Lanza las peticiones necesarias iniciales al servidor.
   */
  async initValuesHttp(): Promise<void> {
    try {
      // await firstValueFrom((this.store.dispatch(new Loader(true, 'Cargando historial del paciente ...'))));
      this.userLogged = this.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER)?.user;
      if (this.userLogged && this.userLogged.experts) {
        this.expertId = this.userLogged.experts[0]._id;
      } else if (this.userLogged && this.userLogged.patients) {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        this.expertId = queryParams.expert;
      }
      this.serviceId = await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId)));
      if (!this.serviceId) {
        await firstValueFrom((this.store.dispatch(new ServiceAction.GetActive(this.patientId, this.expertId))));
        this.serviceId = await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId)));
      }
      await firstValueFrom((this.store.dispatch(new RecordNutritionalHistoryAction.GetActive(this.serviceId, this.patientId, this.expertId))));
      this.recordNutritional = cloneDeep(await firstValueFrom((this.store.selectOnce(NutritionalHistoryState.getRecordNutritionalHistory))));

      for (const prop in this.recordNutritional) {
        if (this.nutritionalForm.get(prop)) {
          this.nutritionalForm.get(prop).setValue(this.recordNutritional[prop] || null);
        }
      }
      this.excludedDislikeIngredients = this.recordNutritional.foodDislikes ?? [];
      this.excludedLikeIngredients = this.recordNutritional.foodLikes ?? [];
      if (!this.userLogged.experts) {
        // tslint:disable-next-line:no-unused-expression
        this.nutritionalForm.disable();
      }
      this.recordNutritional.foodSchedules?.forEach(item => {
        const has = this.timeMeals?.find(time => time.info.timeFoodName === item.foodTime);
        if (has) {
          has.info.from = item.startTime;
          has.info.to = item.endTime;

          has.auxInfo = { ...has.info };
        }
      });
      this.recordNutritional.cereals?.forEach(item => {
        const has = this.cereals.find(time => time.info.timeFoodName === item.foodTime);
        if (has) {
          has.info.textValue = item.text;
          has.info.quantity = item.amount;
          has.info.unit = item.measureUnit;

          has.auxInfo = { ...has.info };
        }
      });
      this.recordNutritional.drinks?.forEach(item => {
        const has = this.beverages.find(time => time.info.timeFoodName === item.foodTime);
        if (has) {
          has.info.textValue = item.text;
          has.info.quantity = item.amount;
          has.info.unit = item.measureUnit;

          has.auxInfo = { ...has.info };
        }
      });
      this.recordNutritional.additionalHighFatFoods?.forEach(item => {
        const has = this.dressings.find(time => time.info.timeFoodName === item.foodTime);
        if (has) {
          has.info.textValue = item.text;

          has.auxInfo = { ...has.info };
        }
      });
      setTimeout(() => {
        this.loadInfo = true;
      });
      this.recordNutritionalChange.emit({ record: this.recordNutritional, updated: false });
      this.excludedAllergyIngredients = this.recordNutritional.allergies ?? [];
    } catch (e) {
      console.error('[RecordHistoryNutritionalComponent] ', e);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  onUpdateValidators(controlName: string): void {
    if (controlName === 'cookingOilOrLard') {
      if (this.nutritionalForm.get(controlName).value && this.nutritionalForm.get(controlName).value === TypesOfFatEnum.OIL) {
        this.nutritionalForm.get('oilName').setValidators([Validators.required]);
        this.nutritionalForm.get('oilName').updateValueAndValidity();
      } else {
        this.nutritionalForm.get('oilName').setValidators([]);
        this.nutritionalForm.get('oilName').updateValueAndValidity();
      }
    } else if (controlName === 'foodTypesBetweenMeals') {
      if (this.nutritionalForm.get(controlName).value && this.nutritionalForm.get(controlName).value !== TypeBetweenMealsEnum.NO) {
        this.nutritionalForm.get('FoodTypesBetweenMealsConsumptionTimes').setValidators([Validators.required]);
        this.nutritionalForm.get('FoodTypesBetweenMealsConsumptionTimes').updateValueAndValidity();
      } else {
        this.nutritionalForm.get('FoodTypesBetweenMealsConsumptionTimes').setValidators([]);
        this.nutritionalForm.get('FoodTypesBetweenMealsConsumptionTimes').updateValueAndValidity();
      }
    }
  }

  onAddOtherNutritionalRegimen(input: HTMLInputElement): void {
    const value = input.value;
    if (!value) return;
    if (this.nutritionalRegimen.filter(regimen => regimen.value === value)) {
      this.nutritionalRegimen.pop();
    }
    this.nutritionalRegimen = [...this.nutritionalRegimen, { value: input.value, label: input.value }];
  }

  onAddOtherNutritionalDressings(input: HTMLInputElement): void {
    const value = input.value;
    if (!value) return;
    if (this.nutritionalDressings.filter(regimen => regimen.value === value)) {
      this.nutritionalDressings.pop();
    }
    this.nutritionalDressings = [...this.nutritionalDressings, { value: input.value, label: input.value }];
  }

  async onSaveNutritionalForm(): Promise<void> {
    this.nutritionalForm.markAllAsTouched();
    this.nutritionalForm.markAsDirty();
    if (!this.nutritionalForm.valid) {
      return;
    }
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Guardando ...'))));
      const nutritionalValue = this.nutritionalForm.getRawValue();
      await firstValueFrom((this.store.dispatch(
        new RecordNutritionalHistoryAction.PutActive(this.serviceId, this.patientId, this.expertId, nutritionalValue)))
      );
      this.messageAlertService.createMessage('success', 'Historial nutricional guardado correctamente');
      this.emitChangeUpdate();
    } catch (e) {
      console.error('[onSaveNutritionalForm] ', e);
      this.messageAlertService.createMessage('error', 'Ha ocurrido un error al guardar los datos');
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  openModalExceedRegisters(): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: '¡Ups parece que has realizado demasiados registros!',
      nzContent: 'Comunicate con DELIE.',
      nzOkText: 'ACEPTAR',
      nzClassName: 'modal-confirm modal-confirm-medium-size',
      nzClosable: false,
      nzOnOk: async () => {
      },
      nzOnCancel: () => {
      }
    });
  }

  async addAllergy(allergy: IAllergy): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Guardando alergia ...'))));
      await firstValueFrom((this.store.dispatch(new RecordNutritionalHistoryAction.PostAllergy(this.serviceId, this.patientId, this.expertId, allergy))));
      this.excludedAllergyIngredients = this.store.selectSnapshot(NutritionalHistoryState.getRecordNutritionalHistory)?.allergies ?? [];
      this.messageAlertService.createMessage('success', 'Alergia registrada correctamente');
      this.emitChangeUpdate();
    } catch (e) {
      console.error('[addAllergy]', e);
      this.messageAlertService.createMessage('error', 'Ha ocurrido un error al registrar la alergia');
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  async onRemoveAllergyIngredient(index: number): Promise<void> {
    try {
      const allergy = this.excludedAllergyIngredients[index];
      if (!allergy) return this.utilitiesService.throwError('Allergy not found');

      await firstValueFrom((this.store.dispatch(new Loader(true, 'Eliminando alergia ...'))));
      await firstValueFrom(this.store.dispatch(
        new RecordNutritionalHistoryAction.DeleteAllergyById(this.serviceId, this.patientId, this.expertId, allergy._id)
      ));
      this.excludedAllergyIngredients.splice(index, 1);
      this.messageAlertService.createMessage('success', 'Alergia eliminada correctamente');
    } catch (ex) {
      console.error('[onRemoveAllergyIngredient] ', ex);
      this.messageAlertService.createMessage('error', 'Ha ocurrido un error al eliminar la alergia');
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  onOpenModalAddAllergy(): void {
    if (this.excludedAllergyIngredients.length >= PLATFORM_CONFIG.RECORDS.NUTRITIONAL_HISTORY.MAX_ALLERGIES) {
      this.openModalExceedRegisters();
      return;
    }
    this.modalAddAllergyVisible = true;
  }

  async onCloseModalAddAllergy(allergies: MiniSphereNamespace.IIngredient[]): Promise<void> {
    if (allergies.length !== this.excludedAllergyIngredients.length) {
      this.excludedAllergyIngredients = allergies;
      const [addAllergy] = cloneDeep(allergies ?? []).reverse();
      await this.addAllergy(addAllergy as IAllergy);
    }
    this.modalAddAllergyVisible = false;
  }


  update(array, value: IDateValue): void {
    if (array[this.indexUpdate]) {
      array[this.indexUpdate] = { ...value };
    }
  }

  emitChangeUpdate(): void {
    this.recordNutritional.updatedAt = new Date();
    this.recordNutritionalChange.emit({ record: this.recordNutritional, updated: true });
  }

  /**
   * horarios para los tiempos de comida
   */
  changeTime(data: ITableResponse): void {
    data.submit = true;
    if (!data.from || !data.to) {
      data.valid = false;
      data.errorMessage = 'Fechas inválidas.';
      return;
    }
    const fromAfterTo = isAfter(new Date(data.to), new Date(data.from));
    if (!fromAfterTo) {
      data.valid = false;
      data.errorMessage = 'Fecha inicial debe ser anterior a la fecha final.';
      return;
    }
    data.valid = true;
    data.status = 'read';
    const foodSchedule: IFoodSchedule = {
      foodTime: data.timeFoodName,
      startTime: data.from,
      endTime: data.to
    };
    this.putTimeFood(foodSchedule).then();
  }

  async putTimeFood(foodSchedule: IFoodSchedule): Promise<void> {
    try {
      await firstValueFrom(this.store.dispatch(new Loader(true, 'Guardando ...')));
      await firstValueFrom(this.store.dispatch(
        new RecordNutritionalHistoryAction.PutFoodSchedule(this.serviceId, this.patientId, this.expertId, foodSchedule))
      );
      const data = this.timeMeals.find(item => item.info.timeFoodName === foodSchedule.foodTime);
      if (data) {
        data.auxInfo = { ...data.info };
      }
    } catch (e) {
      console.error('[putTimeFood] ', e);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  /**
   * celerales para los tiempos de comida
   */
  changeCereals(data: ITableResponse): void {
    data.submit = true;
    if (!data.textValue || !data.quantity || !data.unit) {
      data.valid = false;
      data.errorMessage = 'Campos inválidos.';
      return;
    }
    data.valid = true;
    data.status = 'read';
    const cereal: IFood = {
      foodTime: data.timeFoodName,
      text: data.textValue,
      amount: data.quantity,
      measureUnit: data.unit
    };
    this.putCereals(cereal).then();
  }

  async putCereals(food: IFood): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Guardando ...'))));
      await firstValueFrom((this.store.dispatch(new RecordNutritionalHistoryAction.PutCereal(this.serviceId, this.patientId, this.expertId, food))));
      const data = this.cereals.find(item => item.info.timeFoodName === food.foodTime);
      if (data) {
        data.auxInfo = { ...data.info };
      }
    } catch (e) {
      console.error('[putCereals] ', e);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  /**
   * bebidas para los tiempos de comida
   */
  changeBeverages(data: ITableResponse): void {
    data.submit = true;
    if (!data.textValue || !data.quantity || !data.unit) {
      data.valid = false;
      data.errorMessage = 'Campos inválidos.';
      return;
    }
    data.valid = true;
    data.status = 'read';
    const beberage: IFood = {
      foodTime: data.timeFoodName,
      text: data.textValue,
      amount: data.quantity,
      measureUnit: data.unit
    };
    this.putBeverages(beberage);
  }

  async putBeverages(food: IFood): Promise<void> {
    try {
      await firstValueFrom(this.store.dispatch(new Loader(true, 'Guardando ...')));
      await firstValueFrom(
        this.store.dispatch(new RecordNutritionalHistoryAction.PutBeverages(this.serviceId, this.patientId, this.expertId, food))
      );
      const data = this.beverages.find(item => item.info.timeFoodName === food.foodTime);
      if (data) {
        data.auxInfo = { ...data.info };
      }
    } catch (e) {
      console.error('[putBeverages] ', e);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  /**
   * aderezos para los tiempos de comida
   */
  async changeDressings(data: ITableResponse): Promise<void> {
    data.submit = true;
    if (!data.textValue) {
      data.valid = false;
      data.errorMessage = 'Campo inválido.';
      return;
    }
    data.valid = true;
    data.status = 'read';
    const beberage: IFood = {
      foodTime: data.timeFoodName,
      text: data.textValue
    };
    await this.putDressings(beberage);
  }

  async putDressings(food: IFood): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Guardando ...'))));
      await firstValueFrom((this.store.dispatch(new RecordNutritionalHistoryAction.PutDressings(this.serviceId, this.patientId, this.expertId, food))));
      const data = this.dressings.find(item => item.info.timeFoodName === food.foodTime);
      if (data) {
        data.auxInfo = { ...data.info };
      }
    } catch (e) {
      console.error('[putDressings] ', e);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  cancelTdOnTable(value: ITableTdCell): void {
    if (value.info && value.auxInfo) {
      value.info = { ...value.auxInfo };
    } else {
      value.info.errorMessage = '';
      value.info.valid = true;
      value.info.from = null;
      value.info.to = null;
      value.info.textValue = '';
      value.info.quantity = null;
      value.info.unit = '';
    }
    value.info.status = 'read';
  }

  async onSelectedDislikeIngredient(ingredient: Partial<IIngredient>): Promise<void> {
    this.excludedDislikeIngredients.push({
      ingredientName: ingredient.name,
      ingredientId: ingredient._id
    });
  }

  async onSelectedLikeIngredient(ingredient: Partial<IIngredient>): Promise<void> {
    this.excludedLikeIngredients.push({
      ingredientName: ingredient.name,
      ingredientId: ingredient._id
    });
  }

  get excludedDislikeIngredientIds(): string[] {
    return this.excludedDislikeIngredients.map((ingredient: MiniSphereNamespace.IIngredient) => ingredient.ingredientId);
  }

  get excludedLikeIngredientIds(): string[] {
    return this.excludedLikeIngredients.map((ingredient: MiniSphereNamespace.IIngredient) => ingredient.ingredientId);
  }

  onRemoveDislikeIngredient(index: number): void {
    this.excludedDislikeIngredients.splice(index, 1);
  }

  onRemoveLikeIngredient(index: number): void {
    this.excludedLikeIngredients.splice(index, 1);
  }

  async onChangeWriteHour(data: ITableTdCell): Promise<void> {
    if (await firstValueFrom(this.isPatient$)) return;
    data.info.status = 'write';
  }

  async ngOnDestroy(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new RecordNutritionalHistoryAction.ResetState())));
    this.wasDeployedSubscription.unsubscribe();
  }
}

